<div id="C{{item.Id}}" class="synapi-item-container" >
    <a [routerLink]="['/fiche',item.Slug+'-'+item.ExternalId]" class="synapi-item-content">
      <div class="synapi-item-metas">
        <div class="synapi-item-openings" *ngIf="item.Categorie?.id=='evenements' && item.LargeOuverturePeriode">
          <i class="lvi-thel-reservation"></i>
          <span *ngIf="(item.LargeOuverturePeriode.Start|date: 'yMd':langService.locale) != (item.LargeOuverturePeriode.End|date: 'yMd')" i18n="@@DateFromTo">Du {{ item.LargeOuverturePeriode.Start|date:"d MMM":'':langService.locale_id}} au {{ item.LargeOuverturePeriode.End|date:"d MMM":'':langService.locale_id}}
          </span>
            <span *ngIf="(item.LargeOuverturePeriode.Start|date: 'yMd') == (item.LargeOuverturePeriode.End|date: 'yMd')" i18n="@@DateThe">Le {{ item.LargeOuverturePeriode.Start|date:"d MMMM y":'':langService.locale_id}}
          </span>
        </div>
        <div class="synapi-item-place" *ngIf="item.AdressePrincipale?.Commune">
          <i class="lvi-thel-lieu"></i>
          <span>{{item.AdressePrincipale.Commune}}</span>
        </div>
      </div>
      <div class="synapi-item-title"><span>{{item.Title}}</span></div>
      <div class="synapi-item-category" *ngIf="item.CategorieDetaillee">
        <span>{{item.CategorieDetaillee.name}}</span>
        <span><i class="lvi lvi-icon-star-flat" *ngFor="let star of stars"></i></span>
      </div>
      <div class="synapi-item-labels" *ngIf="item.Labels.length>0">
        <synapi-item-label [size]="32" [label]="label" *ngFor="let label of labels"></synapi-item-label>
      </div>
    </a>
    <div class="synapi-item-bookmark">
      <synapi-bookmark-toggle [item]="item"></synapi-bookmark-toggle>
    </div>
    <a [routerLink]="['/fiche',item.Slug+'-'+item.ExternalId]"  class="synapi-item-media-container">
      <media-attachment [forceBackground]="true" [alt]="item.Title" [sizeXL]="10" [sizeLG]="10" [sizeMD]="10" [sizeSM]="10" [sizeXS]="10" class="synapi-item-media" [url]="item.ImageUrl"></media-attachment>
    </a>
</div>
